import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownReactiveFormModule} from '../../../../../shared-components/dropdowns/dropdown-reactive-form/dropdown-reactive-form.module';
import {FormControlErrorMessagesModule} from '../../../../../pipes/form-control-error-messages/form-control-error-messages.module';
import {FormControlModule} from '../../../../../pipes/form-control/form-control.module';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ReservationsHttpService} from '../../../../../services/http-services/reservations/reservations-http.service';
import {JmbgRegex, PibRegex} from '../../../../../constants/general-variables';
import {NgIf} from '@angular/common';

@Component({
  selector: 'gr-refund-presents-modal',
  templateUrl: './refund-presents-modal.component.html',
  standalone: true,
  imports: [
    DropdownReactiveFormModule,
    FormControlErrorMessagesModule,
    FormControlModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf
  ]
})
export class RefundPresentsModalComponent implements OnInit {
  @Input() refundData: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  refundGiftsForm!: FormGroup;
  formTriedToSubmit = false;

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private reservationsHttpService: ReservationsHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.refundGiftsForm.controls.refund_type.valueChanges.subscribe(value => {
      const buyerId = this.refundGiftsForm.get('buyer_id');
      if (value === 'person') {
        buyerId?.clearValidators();
        buyerId?.setValidators([Validators.required, Validators.required, Validators.pattern(JmbgRegex)]);
      } else {
        buyerId?.clearValidators();
        buyerId?.setValidators([Validators.required, Validators.required, Validators.pattern(PibRegex)]);
      }
    });
  }

  buildForm(): void {
    this.refundGiftsForm = this.formBuilder.group({
      refund_type: ['person'],
      gifts: [[], Validators.required],
      reservation_id: ['', Validators.required],
      buyer_id: ['', [Validators.required, Validators.pattern(JmbgRegex)]],
    });
    this.refundGiftsForm.patchValue(this.refundData);
  }

  submitEditUserForm(): void {
    this.formTriedToSubmit = true;
    if (this.refundGiftsForm.valid) {
      this.reservationsHttpService.postRefundGifts(this.refundGiftsForm.value).then(res => {
        this.confirmModal.emit();
        this.toastService.success(res.message);
      }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
        Object.values(error.errors).forEach(error => this.toastService.error(error));
      });
    }
  }
}
